export default __webpack_public_path__ + "static/media/Logo.9f583fc6.jpg";